export const replaceFirstDigit = (phoneNumber: string): string => {
  return phoneNumber.replace(/^7/, "8");
};
